import React from 'react';
import { CustomRolePermissionDto } from '../../../../../../api-client';
import { Button, Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { AccessControl } from '../../../../../../common';
import { AccessDeniedButton } from '../../../../../../common/styles/AccessDenied.styles';

type DeletePermissionFromCustomRoleButtonProps = {
  permission: CustomRolePermissionDto;
  openCustomRolePermissionDeleteModal: (permission: CustomRolePermissionDto) => void;
};

type DeletePermissionFromCustomRoleButtonComponent =
  React.FC<DeletePermissionFromCustomRoleButtonProps>;

export const DeletePermissionFromCustomRoleButton: DeletePermissionFromCustomRoleButtonComponent =
  ({ permission, openCustomRolePermissionDeleteModal }) => {
    return (
      <Flexbox container gutter={2} justifyContent="flex-end">
        <AccessControl
          permission="iam.custom-role.update"
          renderIfNoAccess={
            <Tooltip
              title={
                <Typography variant="caption" color={() => 'white'}>
                  You do not have permissions to perform this action.
                  <br />
                  Required permissions: {/*@ts-ignore*/}
                  <Typography variant="caption" weight="bold">
                    iam.custom-role.update
                  </Typography>
                </Typography>
              }
            >
              <AccessDeniedButton variant="icon" data-testid="delete-permission" disabled>
                <Icon.Delete size="sm" color={() => '#757575'} />
              </AccessDeniedButton>
            </Tooltip>
          }
        >
          <Button
            variant="icon"
            data-testid={`delete-${permission.id}-from-custom-role`}
            onClick={() => {
              openCustomRolePermissionDeleteModal(permission);
            }}
          >
            <Icon.Delete size="sm" />
          </Button>
        </AccessControl>
      </Flexbox>
    );
  };
